import React from "react";

const LoginWrapper = ({ left, right, mainClass = "Login" }) => {
  return (
    <main className={mainClass} role="login-wrapper">
      <section>{left}</section>

      <aside>{right ? right : <img className="msb-powered-logo" />}</aside>
    </main>
  );
};

export default LoginWrapper;
